import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.map.js";
export default {
  data() {
    return {
      data: [],
      columns: [{
        slots: {
          title: '序号'
        },
        dataIndex: 'attachId',
        key: '1',
        align: 'center'
      }, {
        slots: {
          title: '产品名称'
        },
        dataIndex: 'name',
        key: '2',
        align: 'center'
      }, {
        slots: {
          title: '购买限制'
        },
        dataIndex: 'limit',
        key: '3',
        align: 'center',
        scopedSlots: {
          customRender: 'limit'
        }
      }],
      dialogVisible: false
    };
  },
  methods: {
    init(data) {
      this.data = data;
      this.dialogVisible = true;
    },
    handleSure() {
      this.$emit('ok', this.data);
    },
    handleEdit() {
      this.data = this.data.map(item => {
        item.limit = "";
        return item;
      });
    }
  }
};